const initialState = {
  position: 0,
  atTop: true,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SCROLL/AT_TOP':
      return {
        ...state,
        atTop: action.payload,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Scroll/Scroll.reducer.js